import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Treatment Success Rate';
const pageSubTitle = 'Treatment Success Rate';
const videoKey = 'Ayf5MS3qNcM';

const TreatmentSuccessRate = () => {
    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <>
                    <p>
                        Treatment Success Rate reflects how important it is for the treatment to work
                        reliably. When this is a top concern, confidence in achieving a positive
                        outcome—such as improved function or reduced pain—becomes a major part of the
                        decision.
                    </p>
                    <p>
                        For example, Total Knee Replacement generally has a higher probability of
                        success, while Hyaluronic Acid Injection has a lower chance of providing lasting
                        improvement. This criterion helps weigh how reliably each option is expected to lead
                        to meaningful results.
                    </p>
                </>
            }
            videoKey={videoKey}
            pageType="criteria"
        />


    );

};

export default TreatmentSuccessRate;